import { fetchWithAuth } from "../fetchWithAuth";

const API_URL = process.env.REACT_APP_API_URL;

export const GetInformationBasicService = async (token) => {
  try {
    const response = await fetchWithAuth(`${API_URL}/information_basic`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    });

    if (!response || !response.ok) {
      return {"error": true, "content": null};
    }

    return {"error": false, "content": await response.json()};
  } catch (error) {
    return {"error": true, "content": null};
  }
};
